import * as _ from "lodash";
import { Roles } from "../../security/roles";
import { SecurityOperations } from "../../security/security-operations";
import { AuthMyfileService } from "../../services/auth.myfile.service";
import { MenuItem } from "./menu-item";
import { ModalType } from "../../enums/modalTypesEnum";
import { LoginType } from "../members/user/user-context.model";
import { PreferenceService } from "../../services/preference.service";

export class Menu {

  constructor() { }

  /***
   * Gets a security trimmed menu for the current User Context.
   */
  static getMenuItems(authMyFileService: AuthMyfileService, preferenceService: PreferenceService): MenuItem[] {
    const menuItems: MenuItem[] = [
      {
        id: 1,
        label: $localize`:@@MENUITEMS_MENU_TEXT: Menu`,
        isTitle: true,
        isVisible: true,
      },
      //Dashboards
      {
        id: 2,
        label: $localize`:@@MENUITEMS_DASHBOARD_TEXT: Dashboards`,
        icon: 'bx bxs-dashboard',
        collapseid: 'sidebarDashboards',
        isVisible: authMyFileService.canAccessOperation(SecurityOperations.dashboard.dashboards),
        subItems: [
          // {
          //   id: 3,
          //   label: $localize`:@@MENUITEMS_DASHBOARD_LIST_ANALYTICSOLD: Analytics-OLD`,
          //   link: '/analytics',
          //   parentId: 2,
          //   isVisible: false,
          // },
          // {
          //   id: 4,
          //   label: $localize`:@@MENUITEMS_DASHBOARD_LIST_CSR:CSR`,
          //   link: '/crm',
          //   parentId: 2,
          //   isVisible: authMyFileService.canAccessOperation(SecurityOperations.dashboard.csr),
          // },
          {
            id: 5,
            label: $localize`:@@MENUITEMS_DASHBOARD_LIST_ANALYTICS: Analytics`,
            link: '',
            parentId: 2,
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.dashboard.dashboards),
          },
          {
            id: 6,
            label: $localize`:@@: Ecommerce`,
            link: '/ecommerce',
            parentId: 2,
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.dashboard.ecommerce),
          },
          // {
          //   id: 6,
          //   label: $localize`:@@MENUITEMS_DASHBOARD_LIST_CRYPTO: Crypto`,
          //   link: '/crypto',
          //   parentId: 2,
          //   isVisible: authMyFileService.canAccessOperation(SecurityOperations.dashboard.crypto),
          // },
          // {
          //   id: 7,
          //   label: $localize`:@@MENUITEMS_DASHBOARD_LIST_PROJECTS: Projects`,
          //   link: '/projects',
          //   parentId: 2,
          //   isVisible: false,  // authMyFileService.canAccessOperation(SecurityOperations.dashboard.projects), 
          // },
          // {
          //   id: 7,
          //   label: 'MENUITEMS_DASHBOARD_LIST_NFT',
          //   link: '/nft',
          //   parentId: 2
          // },
          // {
          //   id: 8,
          //   label: 'MENUITEMS_DASHBOARD_LIST_JOB',
          //   link: '/job',
          //   badge: {
          //     variant: 'bg-success',
          //     text: 'MENUITEMS_DASHBOARD_BADGE',
          //   },
          //   parentId: 2,
          // }
        ]
      },
      //Calendar
      {
        id: 1234,
        label: $localize`:@@: Calendar`,
        link: '/calendar',
        icon: 'bx bx-calendar',
        isVisible: true,
        badge: {
          variant: 'bg-success',
          text: $localize`:@@: New`,
          visible: false
        },
      },
      //Communication
      // {
      //   id: 180,
      //   label: $localize`:@@MENUITEMS_COMM_TEXT: Communication`,
      //   icon: 'bx bx-chat',
      //   collapseid: 'sidebarComm',
      //   isVisible: authMyFileService.canAccessOperation(SecurityOperations.comunication.chat),
      //   subItems: [
      //     {
      //       id: 181,
      //       label: $localize`:@@MENUITEMS_COMM_CHAT: Chat`,
      //       parentId: 180,
      //       link: '/chat',
      //       isVisible: authMyFileService.canAccessOperation(SecurityOperations.comunication.chat),
      //     },
      //     {
      //       id: 182,
      //       label: $localize`:@@MENUITEMS_COMM_CALENDAR: Calendar`,
      //       parentId: 180,
      //       link: '/calendar',
      //       isVisible: authMyFileService.canAccessOperation(SecurityOperations.comunication.calendar),
      //     },
      //   ]
      // },
      //MyFile Marketplace
      {
        id: 20,
        label: $localize`:@@MENUITEMS_MARKETPLACE_TEXT: Marketplace`,
        icon: 'bx bx-layer',
        collapseid: 'sidebarMarketplace',
        isVisible: authMyFileService.canAccessOperation(SecurityOperations.marketplace.marketplace),
        subItems: [
          {
            id: 21,
            label: $localize`:@@MENUITEMS_MARKETPLACE_MARKETPLACE: Marketplace`,
            parentId: 20,
            link: '/marketplace/marketplace',
            isVisible: true,
          },
          {
            id: 22,
            label: $localize`:@@MENUITEMS_MARKETPLACE_EXPLORE: Explore Now`,
            parentId: 20,
            link: '/marketplace/explore',
            isVisible: true,
            //isVisible: authMyFileService.canAccessOperation(SecurityOperations.marketplace.explore),
          },
          {
            id: 23,
            label: $localize`:@@MENUITEMS_CHECKOUT_TEXT: Check Out`,
            parentId: 20,
            link: '/ecommerce/checkout',
            isVisible: true,
            //isVisible: authMyFileService.canAccessOperation(SecurityOperations.marketplace.explore), 
          }
        ]
      },
      //Tasks
      {
        id: 120,
        label: $localize`:@@MENUITEMS_TASK_TEXT: Tasks`,
        icon: 'bx bx-task',
        isVisible: false, // authMyFileService.canAccessOperation(SecurityOperations.task.tasks),
        // parentId: 8,
        subItems: [
          {
            id: 121,
            label: $localize`:@@MENUITEMS_TASK_KANBANBOARD: Kanban Board`,
            link: '/tasks/kanban',
            parentId: 120,
            isVisible: false // authMyFileService.canAccessOperation(SecurityOperations.task.tasks),
          },
          {
            id: 122,
            label: $localize`:@@MENUITEMS_TASK_MANAGEMENT: Task Management`,
            link: '/tasks/list-view',
            parentId: 121,
            isVisible: false //authMyFileService.canAccessOperation(SecurityOperations.task.taskManagement),
          },
          {
            id: 123,
            label: $localize`:@@MENUITEMS_TASK_TODO: To Do`,
            link: '/todo',
            parentId: 121,
            isVisible: false // authMyFileService.canAccessOperation(SecurityOperations.task.taskUpdate),
          },
          {
            id: 123,
            label: $localize`:@@MENUITEMS_TASK_TASKDETAILS: Task Details`,
            link: '/tasks/details',
            parentId: 121,
            isVisible: false //authMyFileService.canAccessOperation(SecurityOperations.task.taskCreate),
          }
        ]
      },
      //Requisition
      {
        id: 555,
        label: $localize`:@@MENUITEMS_MYREQS_TEXT: My Requisitions`,
        icon: 'bx bx-bar-chart-square',
        collapseid: 'sidebarRequisitions',
        isVisible: authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionManagement),
        subItems: [
          {
            id: 565,
            label: $localize`:@@MENUITEMS_MYREQS_MANAGEMENT: Requisition Management`,
            parentId: 555,
            link: '/requisitions/list',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionManagement),
          },
          {
            id: 575,
            label: $localize`:@@MENUITEMS_REQ_CREATE: Create New`,
            parentId: 555,
            link: '/marketplace/explore',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.requisition.requisitionCreate)

          },
        ]
      },
      //File Manager
      {
        id: 160,
        label: $localize`:@@MENUITEMS_FILEMANAGER: File Manager`,
        link: '/file-manager',
        icon: 'bx bx-file',
        isVisible: false //authMyFileService.canAccessOperation(SecurityOperations.file.fileManager)
      },

      //Clients
      {
        id: 55,
        label: $localize`:@@MENUITEMS_CLIENT_TEXT: Clients`,
        icon: 'bx bx-user-circle',
        collapseid: 'sidebarClients',
        isVisible: authMyFileService.canAccessOperation(SecurityOperations.client.clientManagement),
        subItems: [
          {
            id: 56,
            label: $localize`:@@MENUITEMS_CLIENT_MANAGEMENT: Client Management`,
            parentId: 55,
            link: '/clients/list',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.client.clientManagement),
          },
          {
            id: 57,
            label: $localize`:@@MENUITEMS_CLIENT_CREATE: Create New`,
            parentId: 55,
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.client.clientCreate),
            modalType: ModalType.ClientModal
          },
          {
            id: 58,
            label: $localize`:@@MENUITEMS_CLIENT_REQUISITION: Note Management`,
            parentId: 55,
            link: '/clients/notes',
            isVisible: true
            //isVisible: authMyFileService.canAccessOperation(SecurityOperations.client.clientCreate),
          },
          // {
          //   id: 58,
          //   label: $localize `:@@MENUITEMS_PROFILE_APIKEY: API Keys`,
          //   link: '/apikey',
          //   parentId: 55,
          //   badge: {
          //     variant: 'bg-success',
          //     text:  $localize `:@@MENUITEMS_PROFILE_APIKEY_NEW: New`,
          //   },
          // },
        ]
      },
      //Contacts
      {
        id: 60,
        label: $localize`:@@MENUITEMS_CONTACT_TEXT: Contacts`,
        icon: 'bx bxs-contact',
        collapseid: 'sidebarContacts',
        isVisible: authMyFileService.canAccessOperation(SecurityOperations.account.accountManagement),
        subItems: [
          {
            id: 61,
            label: $localize`:@@MENUITEMS_CONTACT_MANAGEMENT: Contact Management`,
            parentId: 60,
            link: '/contacts/list',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.account.accountManagement),
          },
          {
            id: 62,
            label: $localize`:@@MENUITEMS_CONTACT_CREATE: Create New`,
            parentId: 60,
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.account.accountCreate),
            modalType: ModalType.ContactModal
          }]
      },
      //Users
      {
        id: 80,
        label: $localize`:@@MENUITEMS_USER_TEXT: Users`,
        icon: 'bx bx-user',
        collapseid: 'sidebarUsers',
        isVisible: authMyFileService.canAccessOperation(SecurityOperations.user.userManagement),
        subItems: [
          {
            id: 81,
            label: $localize`:@@MENUITEMS_USER_MANAGEMENT: User Management`,
            parentId: 80,
            link: '/users/list',
            icon: 'bx bx-user',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.user.userManagement),
          },

        ]
      },
      //Profile
      {
        id: 100,
        label: $localize`:@@MENUITEMS_PROFILE_TEXT: Profile`,
        icon: 'bx bxs-user-circle',
        collapseid: 'sidebarProfile',
        isVisible: (authMyFileService.currentUserContextValue?.loginType == LoginType.User),
        subItems: [
          {
            id: 101,
            label: $localize`:@@MENUITEMS_PROFILE_OVERVIEW: Overview`,
            parentId: 100,
            link: '/pages/profile',
            icon: 'bx bx-user',
            isVisible: true,
          },
          {
            id: 102,
            label: $localize`:@@MENUITEMS_PROFILE_PROFILE: My Profile`,
            parentId: 55,
            link: '/pages/profile-setting',
            icon: 'bx bx-user',
            isVisible: true,
          },
          {
            id: 102,
            label: $localize`:@@MENUITEMS_PROFILE_LOGINHISTORY: My Login History`,
            parentId: 55,
            link: '/pages/login-history',
            icon: 'bx bx-history',
            isVisible: (authMyFileService.loginTypeIsUser() && (!authMyFileService.isInRole(Roles.guest))),
          },
          // {
          //   id: 103,
          //   label: $localize`:@@MENUITEMS_PROFILE_TIMELINE: Timeline/History`,
          //   parentId: 55,
          //   link: '/pages/timeline',
          //   icon: 'bx bx-user',
          //   isVisible: (authMyFileService.isInRole(Roles.admin) || authMyFileService.isInRole(Roles.globalAdmin)),
          // },
          {
            id: 792,
            label: $localize`:@@: Notifications`,
            parentId: 55,
            link: '/operations/notifications',
            icon: 'bx bx-bell',
            isVisible: true
          }
        ]
      },
      {
        id: 100,
        label: $localize`:@@MENUITEMS_PROFILE_TEXT: Profile`,
        icon: 'bx bxs-user-circle',
        collapseid: 'sidebarProfile',
        isVisible: (authMyFileService.currentUserContextValue?.loginType == LoginType.Client),
        subItems: [
          {
            id: 101,
            label: $localize`:@@MENUITEMS_PROFILE_PROFILE: My Profile`,
            parentId: 100,
            modalType: ModalType.ClientModal,
            icon: 'bx bx-user',
            isVisible: (authMyFileService.currentUserContextValue?.loginType == LoginType.Client),
          },
          {
            id: 102,
            label: $localize`:@@MENUITEMS_PROFILE_LOGINHISTORY: My Login History`,
            parentId: 55,
            link: '/pages/login-history',
            icon: 'bx bx-history',
            isVisible: (authMyFileService.currentUserContextValue?.loginType == LoginType.Client),
          },
          {
            id: 792,
            label: $localize`:@@: Notifications`,
            parentId: 55,
            link: '/operations/notifications',
            icon: 'bx bx-bell',
            isVisible: true
          }
        ]
      },
      //Invite
      {
        id: 160,
        label: $localize`:@@MENUITEMS_INVITE_TEXT: Invite`,
        link: '',
        icon: 'bx bx-user-plus',
        isVisible: authMyFileService.canAccessOperation(SecurityOperations.user.userCreate) || authMyFileService.canAccessOperation(SecurityOperations.client.clientCreate),
        collapseid: 'inviteModal',
        subItems: [
          {
            id: 161,
            label: $localize`:@@MENUITEMS_INVITE_USER: Invite User`,
            parentId: 160,
            icon: 'bx bx-user',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.user.userCreate),
            modalType: ModalType.InviteUser
          },
          {
            id: 162,
            label: $localize`:@@MENUITEMS_INVITE_CLIENT: Invite Client`,
            parentId: 160,
            icon: 'bx bx-user',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.client.clientCreate),
            modalType: ModalType.InviteClient
          },
        ]
      },
      //ImportExportEntities
      {
        id: 790,
        label: $localize`:@@: Import Management `,
        icon: 'bx bx-duplicate',
        link: '/operations/import',
        isVisible: authMyFileService.canAccessOperation(SecurityOperations.importExport.importExportManagement),
        badge: {
          visible: true,
          variant: 'bg-danger',
          count: `0`,
          counter: true,
        },
      },

      //Invoice
      {
        id: 770,
        label: $localize`:@@: Invoices`,
        icon: 'bx bxs-bank',
        collapseid: 'sidebarContacts',
        isVisible: authMyFileService.canAccessOperation(SecurityOperations.invoice.invoiceManagement) || authMyFileService.canAccessOperation(SecurityOperations.invoice.invoiceReadBillingHistory),
        subItems: [
          {
            id: 771,
            label: $localize`:@@: Invoice Management`,
            parentId: 60,
            link: '/invoice/list',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.invoice.invoiceManagement),
          },
          {
            id: 772,
            label: $localize`:@@: Billing History`,
            parentId: 60,
            link: '/invoice/billing',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.invoice.invoiceReadBillingHistory),
          }
        ]
      },
      //Wallet


      //System
      {
        id: 240,
        label: $localize`:@@MENUITEMS_SYSTEM_TEXT: System`,
        link: '',
        icon: 'bx bx-aperture',
        isVisible: (authMyFileService.isInRole(Roles.admin) || authMyFileService.isInRole(Roles.globalAdmin)) || (authMyFileService.canAccessOperation(SecurityOperations.wallet.walletManagement)),
        // badge: {
        //   variant: 'bg-success',
        //   text:  $localize `:@@MENUITEMS_PROFILE_APIKEY_NEW: Admin`,
        // },
        subItems: [
          {
            id: 249,
            label: $localize`:@@: Hangfire`,
            parentId: 220,
            link: '/pages/hangfire',
            text: $localize`:@@MENUITEMS_SETTINGS_SECURITY_Admin: Admin`,
            isVisible: (authMyFileService.isInRole(Roles.admin) || authMyFileService.isInRole(Roles.globalAdmin)),
          },
          {
            id: 250,
            label: $localize`:@@: API Swagger`,
            link: 'pages/swagger',
            parentId: 220,
            isVisible: (authMyFileService.isInRole(Roles.admin) || authMyFileService.isInRole(Roles.globalAdmin)),
          },
          {
            id: 251,
            label: $localize`:@@: Finite State Machines`,
            link: 'pages/fsm',
            parentId: 220,
            isVisible: (authMyFileService.isInRole(Roles.admin) || authMyFileService.isInRole(Roles.globalAdmin)),
          },
          {
            id: 252,
            label: $localize`:@@: Recent Activity`,
            link: 'pages/recent-activity',
            parentId: 220,
            isVisible: (authMyFileService.isInRole(Roles.admin) || authMyFileService.isInRole(Roles.globalAdmin)),
          },
          {
            id: 206,
            label: $localize`:@@: Settings`,
            parentId: 200,
            link: '/pages/settings',
            icon: '',
            isVisible: authMyFileService.isInRole(Roles.globalAdmin)
          },

          {
            id: 207,
            label: $localize`:@@: Business Unit Settings`,
            parentId: 200,
            link: '/pages/business-settings',

            icon: '',
            isVisible: (authMyFileService.isInRole(Roles.admin) || authMyFileService.isInRole(Roles.globalAdmin)),
          },
          {
            id: 208,
            label: $localize`:@@:Document Templates`,
            parentId: 200,
            link: '/pages/ExploreDocumentTemplates',
            icon: '',
            isVisible: (authMyFileService.isInRole(Roles.admin) || authMyFileService.isInRole(Roles.globalAdmin)),
          },
          {
            id: 209,
            label: $localize`:@@:Email Templates`,
            parentId: 200,
            link: '/pages/EmailTemplates',
            icon: '',
            isVisible: (authMyFileService.isInRole(Roles.admin) || authMyFileService.isInRole(Roles.globalAdmin)),
          },
          {
            id: 560,
            label: $localize`:@@: Wallet Settings`,
            link: '/pages/wallet',
            icon: 'bx bx-wallet',
            isVisible: authMyFileService.canAccessOperation(SecurityOperations.wallet.walletManagement),
          },
        ]
      },
      {
        id: 161,
        label: $localize`:@@: Insights`,
        link: '/pages/blogs',
        icon: 'ri-lightbulb-line',
        iconColor: `yellow-color-only`,
        isVisible: (authMyFileService.loginTypeIsUser() && (!authMyFileService.isInRole(Roles.guest))), //authMyFileService.canAccessOperation(SecurityOperations.file.fileManager)
        badge: {
          variant: 'bg-success',
          text: $localize`:@@: New`,
          visible: true
        },
      },
      {
        id: 162,
        label: $localize`:@@: How To Center`,
        link: `/pages/how-to-center`,
        icon: 'ri-file-info-line',
        iconColor: `blue-color-only`,
        isVisible: (authMyFileService.loginTypeIsUser() && (!authMyFileService.isInRole(Roles.guest))),
        badge: {
          variant: 'bg-success',
          text: $localize`:@@: New`,
          visible: true
        },
      },
      //About Us
      {
        id: 200,
        label: $localize`:@@MENUITEMS_ABOUTUS_TEXT: About Us`,
        link: '',
        icon: 'bx bx-unite',
        collapseid: 'sidebarAbout',
        isVisible: true,
        badge: {
          variant: 'bg-success',
          text: $localize`:@@: New`,
          visible: preferenceService.needsToViewUpdates()
        },
        subItems: [
          {
            id: 206,
            label: $localize`:@@: Release Notes`,
            parentId: 200,
            link: '/pages/release-notes',
            //outwardlink: 'https://myfile.ca/terms-conditions',
            icon: 'bx bx-user',
            isVisible: (authMyFileService.loginTypeIsUser() && (!authMyFileService.isInRole(Roles.guest))),
            badge: {
              variant: 'bg-success',
              text: $localize`:@@: New`,
              visible: true
            },
          },
          {
            id: 201,
            label: $localize`:@@MENUITEMS_ABOUTUS_TERMS: Terms`,
            parentId: 200,
            link: '/pages/terms-condition',
            //outwardlink: 'https://myfile.ca/terms-conditions',
            icon: 'bx bx-user',
            isVisible: true,
          },
          {
            id: 202,
            label: $localize`:@@MENUITEMS_ABOUTUS_PRIVACYPOLICY: Privacy Policy`,
            parentId: 200,
            link: '/pages/privacy-policy',
            // outwardlink: 'https://myfile.ca/privacy-policy',
            icon: 'bx bx-user',
            isVisible: true,
          },
          {
            id: 203,
            label: $localize`:@@MENUITEMS_ABOUTUS_FAQ: FAQ`,
            parentId: 200,
            // link: '/pages/faqs',
            outwardlink: 'https://myfile.ca/faq',
            icon: 'bx bx-user',
            isVisible: authMyFileService.loginTypeIsUser(),
          },
          {
            id: 204,
            label: $localize`:@@MENUITEMS_ABOUTUS_PRICING: Pricing`,
            parentId: 200,
            link: '/pages/pricing',
            icon: 'bx bx-user',
            isVisible: false,
          },
          {
            id: 205,
            label: $localize`:@@MENUITEMS_ABOUTUS_CONTACTUS: Contact Us`,
            parentId: 200,
            outwardlink: 'https://myfile.ca/contact',
            icon: 'bx bx-user',
            isVisible: false,
          }
        ]
      },
    ];

    return menuItems;
  }
} 